import {handleActions} from 'redux-actions';
import {createReducer} from "../baseReducer/baseReducer";


// ------------------------------------
// Constants
// ------------------------------------

export const { reducers, initialState, actions } = createReducer(
    "perfiles",
    "perfil_finca",
    "PerfilForm",
    "/perfiles",
);

export default handleActions(reducers, initialState);
